<div class="side-navigation-wrapper">
    <div class="side-navigation" *ngIf="(filterView$ | async) as filterView" [ngClass]="{'active': filterView.sideNavOpen}">
        <div class="hidden-desktop">
            <div (click)="sideNavToggle()" class="toggle-side-nav">
                <span class="text-uppercase" translate="cart.categories"></span>
                <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
            </div>
        </div>
        <div class="filter-wrapper">
            <div class="filter-panel" *ngIf="(lifestyles$ | async)?.length > 0">
                <div class="group-title text-uppercase" translate="cart.shop.by.lifestyle"></div>
                <ul class="filter-list" *ngFor="let tags of (lifestyles$ | async); trackBy: trackByFn">
                    <ng-container *ngFor="let tag of tags.children; trackBy: trackByFn">
                        <li class="filter-list-item" [ngClass]="tag.id == filterView.selectedTag?.id ? 'active': ''" *ngIf="tag.plpFilterDisplay">
                            <div>
                                <a (click)="clearFilters()" [routerLink]="[TAG_CATALOG_ROUTE, tag.id]" translate="cart.tag.{{tag.name}}"></a>
                            </div>
                        </li>
                    </ng-container>
                </ul>
            </div>

            <div class="filter-panel" *ngIf="(bodyBenefits$ | async)?.length > 0">
                <div class="group-title text-uppercase" translate="cart.shop.by.body.benefit"></div>
                <ul class="filter-list" *ngFor="let tags of (bodyBenefits$ | async); trackBy: trackByFn">
                    <ng-container *ngFor="let tag of tags.children; trackBy: trackByFn">
                        <li class="filter-list-item" [ngClass]="tag.id == filterView.selectedTag?.id ? 'active': ''"  *ngIf="tag.plpFilterDisplay">
                            <div>
                                <a (click)="clearFilters()" [routerLink]="[TAG_CATALOG_ROUTE, tag.id]" translate="cart.tag.{{tag.name}}"></a>
                            </div>
                        </li>
                    </ng-container>
                </ul>
            </div>

            <accordion class="filter-panel" closeOthers="true">
                <div class="group-title">
                    <span translate="cart.shop.by.category"></span>
                </div>
                <accordion-group #categoryGroup *ngFor="let category of (navCategories$ | async); let i = index; trackBy: trackByFn" [isOpen]="category.id == filterView.parentCategory?.id">
                    <div *ngIf="i == 0 && showAllProductsLink()" accordion-heading>
                        <a [ngClass]="category.id == filterView.selectedCategory?.id ? 'active': ''"
                           (click)="clearFilters()"
                           [routerLink]="[CATALOG_ROUTE, category.id]" [translate]="category.translationTag"></a>
                    </div>
                    <div *ngIf="i > 0" accordion-heading class="collapsed">
                        {{category.translationTag | translate}}
                        <i class="pull-right fa-solid" [ngClass]="isAccordionOpen(categoryGroup.isOpen)"></i>
                    </div>
                    <div class="subcategory" *ngIf="i > 0">
                        <a (click)="clearFilters()"
                           [routerLink]="[CATALOG_ROUTE, category.id]"
                           [ngClass]="category.id == filterView.selectedCategory?.id ? 'active': ''"><span
                            translate="cart.catalog.all.{{category.name}}"></span></a>
                        <a *ngFor="let subCat of category.children; trackBy: trackByFn"
                           (click)="clearFilters()"
                           [routerLink]="[CATALOG_ROUTE, subCat.id]"
                           [ngClass]="subCat.id == filterView.selectedCategory?.id ? 'active': ''" [translate]="subCat.translationTag"></a>
                    </div>
                </accordion-group>
            </accordion>
        </div>
    </div>

    <div class="overlay" (click)="sideNavToggle()"></div>
</div>

